'use client';

import { c as _c } from "react/compiler-runtime";
import { UISwitcher } from '@/comps/ui/buttons/UISwitcher/UISwitcher';
import { SPEND_CHART_MODE_OPTIONS, type SpendChartMode } from '@/domains/pages/ai-spend/constants';
import { cn } from '@/utils/shad';
type SpendChartModeTabsProps = {
  value: SpendChartMode;
  onValueChange: (mode: SpendChartMode) => void;
  className?: string;
};
export function SpendChartModeTabs(t0) {
  const $ = _c(7);
  const {
    value,
    onValueChange,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("max-w-max shrink-0", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = SPEND_CHART_MODE_OPTIONS.map(_temp);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onValueChange || $[4] !== t1 || $[5] !== value) {
    t3 = <UISwitcher className={t1} value={value} onChange={onValueChange} items={t2} />;
    $[3] = onValueChange;
    $[4] = t1;
    $[5] = value;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function _temp(option) {
  return {
    value: option.value,
    label: option.label
  };
}